import * as React from 'react';
import { genBlock } from '@/utils/bem';
import './style.less';

export interface BrandItemData {
  img: string;
  url: string;
  title: string;
  position: React.CSSProperties;
  itemStyle?: React.CSSProperties;
  wrapRect?: DOMRect;
}

const block = genBlock('wx-brand-item')

export const BrandItem: React.FC<BrandItemData> = ({
  img,
  title,
  position,
  itemStyle = {},
  wrapRect = {},
  url,
}) => {
  const itemRef = React.useRef<HTMLDivElement>();
  const itemRectRef = React.useRef<DOMRect>();
  const limitRef = React.useRef<[number, number]>([-50, 100]);
  const intervalIdRef = React.useRef<NodeJS.Timeout>();
  const [style, setStyle] = React.useState(position);

  React.useEffect(() => {
    itemRectRef.current = itemRef.current.getBoundingClientRect();
    setTimeout(() => {
      itemRectRef.current = itemRef.current.getBoundingClientRect();
      intervalIdRef.current = setInterval(handleInterval, 1000);
    }, 200)
  }, []);

  React.useEffect(() => {
    // 换算item高度成百分比，确定容器高度
    const itemHeightPercent = Math.ceil(
      (itemRectRef.current.height / wrapRect.height) * 100
    );
    limitRef.current = [-itemHeightPercent / 2, 100];
  }, [wrapRect, itemRectRef.current]);

  const handleInterval = () => {
    setStyle((state) => {
      const curStyle = { ...state };
      if (curStyle.top >= limitRef.current[1]) {
        curStyle.opacity = 1;
      }

      if (curStyle.top <= limitRef.current[0]) {
        curStyle.top = limitRef.current[1];
        curStyle.opacity = 0;
      } else {
        curStyle.top = (curStyle.top as number) - 5;
      }

      return curStyle;
    });
  };

  const changeUnit = () => {
    const curStyle = { ...style };
    curStyle.top = curStyle.top + "%";
    return curStyle;
  };

  const handdleClick = () => {
    if (url) {
      window.location.href = url
    }
  }

  return (
    <div
      className={block("item")}
      style={{ ...changeUnit(), ...itemStyle }}
      ref={itemRef}
      onClick={handdleClick}
    >
      <img src={img} alt="" className={block("item-img")}/>
      <div className={block("item-title")}>{title}</div>
    </div>
  );
};
